<template>
    <div class="mapPage">
        <div class="mapTop">
            <div class="topLeft">黉门电工-智能运维产品应用分布图</div>
            <div class="timeStr">{{ newTime }}</div>
            <div class="topRight">
                <div class="topRightContent">
                    <div class="imageTitle">
                        <img src="../../style/img/glkgxt.svg" width="30" height="25" />
                    </div>
                    <div class="systemDiv">
                        <div @click="toIndex" class="systemName">DMSM<span class="systemClick">[ 进入系统 ]</span></div>
                        <div class="systemSum">{{ sumNumber }}<span class="systemUnit">套</span> </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mapPageContent">
            <div class="mapPageLeft">
                <div ref="ct" class="chinaMapBox">
                    <div ref="charts" class="mapDiv" style="width: 100%; height: 100%"></div>
                    <!-- <div class="divRoll">
                        <div class="content">
                            <div>
                                <ul class="rowup">
                                    <li :key="index" v-for="(item, index) in dataLi">{{ item.title }} {{ item.type }}</li>
                                </ul>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="mapBottom">
                    <div class="topDiv" v-for="(item, index) in mapData" :key="index">
                        <div class="topName">{{ item.name }}</div>
                        <div class="topSU">
                            <div class="topSum">{{ item.value }}</div>
                            <div class="topUnit">套</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mapPageRight">
                <div class="right1">
                    <img src="../../style/img/bdz.png" width="38" height="38" />
                    <div style="font-size: 18px;font-weight: 400;color: #d6d7d9;margin-left: 30px;">应用变电站</div>
                    <div style="font-size: 26px;font-weight: 400;color: #67adff;margin-left: 30px;">{{ useNum }}</div>
                    <div style="font-size: 16px;font-weight: 400;color: #929598;margin-left: 30px;">座</div>
                </div>
                <div class="right2">
                    <divTopName title="变电站电压等级"></divTopName>
                    <div class="right2Content">
                        <div class="right2Div" v-for="(item, index) in dengjiArr" :key="index">
                            <div class="right2DivName">{{ item.dictValue }}</div>
                            <div class="right2DivSU">
                                <div class="right2DivSum">{{ item.num }}</div>
                                <div class="right2DivUnit">座</div>
                            </div>
                        </div>
                        <!-- <div class="right2Div">
                            <div class="right2DivName">1000kV</div>
                            <div class="right2DivSU">
                                <div class="right2DivSum">375</div>
                                <div class="right2DivUnit">座</div>
                            </div>
                        </div>
                        <div class="right2Div">
                            <div class="right2DivName">1000kV</div>
                            <div class="right2DivSU">
                                <div class="right2DivSum">375</div>
                                <div class="right2DivUnit">座</div>
                            </div>
                        </div>
                        <div class="right2Div">
                            <div class="right2DivName">1000kV</div>
                            <div class="right2DivSU">
                                <div class="right2DivSum">375</div>
                                <div class="right2DivUnit">座</div>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="right3">
                    <divTopName title="本年每月采集数据量统计"></divTopName>
                    <!-- <div class="right3Title">累计总数据量 {{ totalNum }}</div> -->
                    <div class="right3Char" ref="right3charts"></div>
                </div>
                <div class="right4">
                    <div class="right4Div">
                        <div class="right4DivTitle">
                            <img src="../../style/img/ljzs.png" width="18" height="18" />
                            <div class="right4DivName">累计数据量</div>
                        </div>
                        <div class="right4DivSum">{{ totalNum }}</div>
                    </div>
                    <div class="right4Div">
                        <div class="right4DivTitle">
                            <img src="../../style/img/zw.png" width="17" height="21" />
                            <div class="right4DivName">指纹数量</div>
                        </div>
                        <div class="right4DivSum">{{ diagData.curveNum }}</div>
                    </div>
                    <div class="right4Div">
                        <div class="right4DivTitle">
                            <img src="../../style/img/sf.png" width="17" height="17" />
                            <div class="right4DivName">诊断库数量</div>
                        </div>
                        <div class="right4DivSum">{{ diagData.diagNum }}</div>
                    </div>
                </div>
                <div class="right5">
                    <divTopName title="不同类型缺陷数量"></divTopName>
                    <div class="right5Content">
                        <div class="right5Div">
                            <img src="../../style/img/you.png" width="16" height="16" />
                            <div class="right5DivName">正常</div>
                            <div class="right4DivSum">{{ defect.typeCodeDefectNum1 }}</div>
                        </div>
                        <div class="right5Div">
                            <img src="../../style/img/yb.png" width="16" height="16" />
                            <div class="right5DivName">一般缺陷</div>
                            <div class="right4DivSum">{{ defect.typeCodeDefectNum2 }}</div>
                        </div>
                        <div class="right5Div">
                            <img src="../../style/img/yz.png" width="16" height="16" />
                            <div class="right5DivName">严重缺陷</div>
                            <div class="right4DivSum">{{ defect.typeCodeDefectNum3 }}</div>
                        </div>
                        <div class="right5Div">
                            <img src="../../style/img/gz.png" width="16" height="16" />
                            <div class="right5DivName">故障</div>
                            <div class="right4DivSum">{{ defect.typeCodeDefectNum4 }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import * as echarts from "echarts";
import mixins from "./mixins";
import { getMap } from "./maputils";
import divTopName from '../../components/divTopName.vue';
import { mapDataQuery, collectDataStat, curveAndDiagNumStat, defectNumStat, subStatQuery, provinceNumSortQuery } from '@/api/map.js'
import { getDictDataByDictType } from '@/api/account.js'

export default {
    components: {
        divTopName
    },
    mixins: [mixins],
    data() {
        return {
            citylist: [{ '中国': "401200965" }],
            lastCity: {},
            cityMapName: "中国",
            zoom: 1,
            domImg: require('@/style/img/mapbj.png'),
            newTime: "",
            charts: null,
            dataLi: [],
            mapData: [],
            totalNum: '',
            diagData: {},
            defect: {},
            sumNumber: 0,
            dengjiArr: [],
            useNum: 0
        };
    },
    async mounted() {
        this.getNowTime();//进入页面调用该方法获取当前时间
        clearInterval(myTimeDisplay);//销毁之前定时器
        var myTimeDisplay = setInterval(() => {
            this.getNowTime(); //每秒更新一次时间
        }, 1000);
        await this.initData();
    },
    methods: {
        async initData() {
            let that = this;
            await axios.all([provinceNumSortQuery(), collectDataStat(), curveAndDiagNumStat(), defectNumStat(), subStatQuery(), getDictDataByDictType({ dicType: 'SUBSTATION_VOLTAGE_LEVEL' })])
                .then(axios.spread(function (resp1, resp2, resp3, resp4, resp5, resp6) {
                    if (resp1.success) {
                        let mapData = [];
                        let sumNumber = 0;
                        (resp1.data || []).forEach((item, index) => {
                            sumNumber += item.num;
                            let isAutonomy = item.provinceName.search('自治区') != -1
                            if (isAutonomy) {
                                mapData.push({
                                    name: item.provinceName.search('内') != -1 ? item.provinceName.substr(0, 3) : item.provinceName.substr(0, 2),
                                    value: item.num,
                                })
                            } else {
                                mapData.push({
                                    name: item.provinceName.match(/(\S*)(省|市|特别行政区)/)[1],
                                    value: item.num,
                                })
                            }
                        });
                        // resp1.data.map((item) => {
                        //     mapData.push({
                        //         name: item.areaName,
                        //         value: item.areaNum,
                        //     })
                        // })
                        that.sumNumber = sumNumber;
                        that.mapData = mapData;
        
                        // var option = that.charts.getOption();
                        // option.series[0].data = mapData;
                        // option.visualMap[0].max = sumNumber ? sumNumber : 300;
                        // that.charts.clear();
                        // that.charts.setOption(option, true);
                        that.initCharts();
                    }
                    if (resp2.success) {
                        let lineData = [];
                        (resp2.data.dataList || []).map((item) => {
                            lineData.push([item.month, item.num])
                        })
                        that.chartsInit(lineData);
                        that.totalNum = resp2.data.totalNum || 0;
                    }
                    if (resp3.success) {
                        that.diagData = resp3.data || {}
                    }
                    if (resp4.success) {
                        let defect = resp4.data || {
                            typeCodeDefectNum1: 0,
                            typeCodeDefectNum2: 0,
                            typeCodeDefectNum3: 0,
                            typeCodeDefectNum4: 0,
                        };
                        // for (let key in defect) {
                        //     console.log(key); // name age
                        //     console.log(defect[key]); // cookie 18
                        //     let data = resp7.data.find(item2 => { 
                        //         return defect[key] == item2.dictLabel;
                        //     });
                        //     defect[key] = data ? data.dictValue : 0
                        // }  
                        that.defect = defect;
                    }
                    if (resp5.success) {
                        let dengjiArr = resp5.data.subNumList || [];
                        let jibieArr = resp6.data || [];
                        jibieArr.map((item) => {
                            let data = dengjiArr.find((item2) => {
                                return item2.substationVoltageLevel == item.dictLabel
                            })
                            item.num = data ? data.num : 0;
                        })
                        // if (dengjiArr.length < 7) {
                        //     for (let i = dengjiArr.length; i < 7; i++) {
                        //         dengjiArr.push({
                        //             substationVoltageLevel: null,
                        //             num: 0
                        //         })
                        //     }
                        // }
                        // dengjiArr.map((item) => {
                        //     let data = resp6.data.find(item2 => {
                        //         return item.substationVoltageLevel == item2.dictLabel;
                        //     });
                        //     item.substationVoltageLevel = data ? data.dictValue : '0kv'
                        // })
                        that.useNum = resp5.data.useSubNum || 0
                        that.dengjiArr = jibieArr
                    }
                }));
        },
        getNowTime() {
            var date = new Date();
            var time = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
            this.newTime = time;
        },
        initCharts() {
            // if (this.chartsData.length === 0) return;
            this.charts = echarts.init(this.$refs["charts"]);
            const option = {
                // 背景颜色
                // backgroundColor: "#404a59",
                // 提示浮窗样式
                tooltip: {
                    show: true,
                    trigger: "item",
                    alwaysShowContent: false,
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    padding: [0, 10, 8, 10],
                    roam: true,
                    hideDelay: 100,
                    triggerOn: "mousemove",
                    enterable: true,
                    borderColor: "rgba(0, 0, 0, 0.7)",
                    //解决浮窗被遮挡
                    confine: true,
                    textStyle: {
                        color: "#fff",
                        fontSize: "12",
                        width: 20,
                        height: 30,
                        overflow: "break",
                    },
                    showDelay: 50,
                    formatter: (params) => {
                        return `<p style="text-align:center;line-height: 30px;height:30px;font-size: 14px;border-bottom: 1px solid #7A8698;">${params.name}</p>
                <div style="line-height:22px;margin-top:5px">终端数量：<span style="margin-left:12px;color:#fff;float:right">${params.data?.value || "--"}</span></div>`;
                    },
                },
                // 地图配置文字显示
                geo: {
                    map: "china",
                    "left": "12%",
                    "right": "12%",
                    "bottom": "3%",
                    "top": "3%",
                    label: {
                        // 通常状态下的样式
                        normal: {
                            show: true,
                            textStyle: {
                                color: "#fff",
                            },
                        },
                        // 鼠标放上去的样式
                        emphasis: {
                            textStyle: {
                                color: "#fff",
                            },
                        },
                    },
                    // 地图区域的样式设置
                    itemStyle: {
                        normal: {
                            borderColor: "rgba(147, 235, 248, 1)",
                            borderWidth: 2,
                            areaColor: {
                                type: "radial",
                                x: 0.5,
                                y: 0.5,
                                r: 0.8,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: "rgba(147, 235, 248, 0)", // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: "rgba(147, 235, 248, .2)", // 100% 处的颜色
                                    },
                                ],
                                globalCoord: false, // 缺省为 false
                                image: this.domImg, //配置图片
                            },
                            shadowColor: "rgba(128, 217, 248, 1)",
                            shadowOffsetX: -2,
                            shadowOffsetY: 2,
                            shadowBlur: 10,
                        },
                        // 鼠标放上去高亮的样式
                        emphasis: {
                            areaColor: "#389BB7",
                            borderWidth: 0,
                        },
                    },
                },
                series: [
                    {
                        type: "map",
                        roam: true,
                        zoom: 1,
                        geoIndex: 0,
                        label: {
                            // 通常状态下的样式
                            normal: {
                                show: true,
                                textStyle: {
                                    color: "#fff",
                                },
                            },
                            // 鼠标放上去的样式
                            emphasis: {
                                textStyle: {
                                    color: "#640000",
                                },
                            },
                        },
                        itemStyle: {
                            normal: {
                                color: "rgba(255, 235, 59, .7)",
                                shadowBlur: 10,
                                shadowColor: "#000",
                            },
                        },
                        data: this.mapData,
                    },
                    // {
                    //     type: "effectScatter",
                    //     coordinateSystem: "geo",
                    //     effectType: "ripple",
                    //     showEffectOn: "render",
                    //     rippleEffect: {
                    //         period: 10,
                    //         scale: 5,
                    //         brushType: "fill",
                    //     },

                    //     hoverAnimation: true,
                    //     itemStyle: {
                    //         normal: {
                    //             color: "rgba(255, 235, 59, .7)",
                    //             shadowBlur: 5,
                    //             shadowColor: "#333",
                    //         },
                    //     },
                    //     zlevel: 1,
                    //     data: [
                    //         { name: "西藏", value: [91.23, 29.5, 2333] },
                    //         { name: "黑龙江", value: [128.03, 47.01, 1007] },
                    //     ],
                    // },
                ],
                visualMap: {
                    show: false,
                    type: "continuous",
                    // 这里最大值写死了，请根据实际需求进行变更
                    //sumNumber为0时，避免全部地图为全红
                    max: this.sumNumber === 0 ? 100 : this.sumNumber,
                    text: ["高", "低"],
                    calculable: true,
                    seriesIndex: [0],
                    inRange: {
                        // 由低到高
                        color: ["rgba(255, 0, 0, 0.3)", "rgba(255, 0, 0, 1)"],
                    },

                    textStyle: {
                        color: "#fff",
                        map: "china",
                    },
                    bottom: "8px",
                    right: "8px",
                    backgroundColor: "#313E52",
                    padding: [10, 8, 10, 8],
                },
                // graphic: {
                //     type: "text",
                //     x: 25,
                //     y: 25,
                //     style: {
                //         text: "返回",
                //         fill: "#fff",
                //         font: 'bolder 2em "Microsoft YaHei", sans-serif'
                //     },
                //     onclick: () => {
                //         // 利用函数的作用域，可以直接拿上面的name来用
                //         if (this.citylist.length < 2) return;
                //         this.lastCity = this.citylist[this.citylist.length - 2];
                //         const name = Object.keys(this.lastCity)[0];
                //         const [grahpName, graphJson] = getMap(name);
                //         // 删除最后一个元素
                //         this.citylist.pop();
                //         // 很多操作重复了，你可以将公共部分抽离出来
                //         option.geo.map = grahpName;
                //         echarts.registerMap(grahpName, graphJson);
                //         this.charts.setOption(option, true);
                //     },
                // },
            };

            const [mapName, mapJson] = getMap(this.cityMapName);
            option.geo.map = mapName;
            // 地图注册，第一个参数的名字必须和option.geo.map一致
            echarts.registerMap(mapName, mapJson);

            this.charts.setOption(option);

            // this.charts.off();
            //下钻
            // this.charts.on("click", (dom) => {
            //     // 阻止散点图点击事件
            //     if (dom.seriesType === "scatter") return;
            //     // 暴露点击事件
            //     const { name: cityname, data } = dom;
            //     const name = cityname ? cityname : Object.keys(this.lastCity)[0];
            //     let code = "";
            //     if (dom.componentType === "series") {
            //         code = data?.areaUniCode ? data?.areaUniCode : this.lastCity[name];
            //     } else {
            //         code = this.lastCity[name];
            //     }
            //     const [mapName, mapJson] = getMap(name);
            //     // console.log(mapJson);
            //     if (mapJson) {
            //         if (dom.componentType === "series") {
            //             this.citylist.push({ [name]: code });
            //         }
            //         this.mapClick(code, name);
            //     }
            //     if (!mapJson) return;

            //     option.geo.map = mapName;
            //     // 设置为undefined，可以保证地图切换时总是居中
            //     option.geo.center = undefined;
            //     echarts.registerMap(mapName, mapJson);
            //     this.charts.setOption(option);
            // });

            this.$refs["charts"].oncontextmenu = () => false;
        },
        // 向父组件提供点击事件，并提供点击省份的code和name
        mapClick(code, name) {
            this.$emit("mapClick", { code, name });
        },
        chartsInit(lineData) {
            let charts = echarts.init(this.$refs["right3charts"]);
            let option = {
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '2%',
                    right: '2%',
                    bottom: '5%',
                    top: '4%',
                    containLabel: true
                },
                color: ['#34E5FF'],
                xAxis: {
                    axisLine: { //x轴线的颜色以及宽度
                        show: true,
                        lineStyle: {
                            color: "#3B4756",
                            width: 1,
                            type: "solid"
                        }
                    },
                    axisLabel: {//x轴文字的配置
                        show: true,
                        textStyle: {
                            color: "#fff",
                        }
                    },
                    type: 'category',
                    data: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
                },
                yAxis: {
                    type: 'value',
                    nameTextStyle: {//y轴上方单位的颜色
                        color: '#fff'
                    },
                    axisLabel: {//y轴文字的配置
                        textStyle: {
                            color: "#fff",
                            margin: 15
                        },
                        // formatter: '{value} %'//y轴的每一个刻度值后面加上‘%’号
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {//y轴线的颜色以及宽度
                        show: true,
                        lineStyle: {
                            color: "#3B4756",
                            width: 1,
                            type: "solid"
                        },
                    },
                    splitLine: {//分割线配置
                        show: true,
                        lineStyle: {
                            width: 1,
                            color: "#3B4756",
                            type: "dashed"
                        }
                    }
                },
                series: [
                    {
                        data: lineData,
                        type: 'line',
                        smooth: true
                    }
                ]
            };
            charts.setOption(option);
        },
        toIndex() {
            this.$router.push({
                path: '/index.html'
            })
        }
    },
};
</script>
<style>
.mapPage {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background-color: #000312;
    padding: 8px;
    overflow-y: auto;
    overflow-x: hidden;
}

.mapPageLeft {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
}

.mapPageRight {
    display: flex;
    flex-direction: column;
    width: 508px;
    height: 100%;
    margin-left: 10px;
}

.mapTop {
    width: 100%;
    height: 100px;
    display: flex;
    position: relative;
}

.timeStr {
    color: #5B79A3;
    font-size: 14px;
    font-weight: bold;
    position: absolute;
    top: 77px;
    left: 20px;
}

.mapDiv {
    background: url(../../style/img/mapbj.png) no-repeat;
    background-position: center;
    background-size: 100% 100%;
}

.mapPageContent {
    display: flex;
    flex: 1;
}

.topLeft {
    width: 40%;
    color: #fff;
    font-size: 40px;
    font-weight: bold;
    line-height: 100px;
    margin-left: 20px;
}

.topRight {
    width: 60%;
    display: flex;
    justify-content: flex-end;
}

.topRightContent {
    width: 20%;
    display: flex;
}

.imageTitle {
    width: 40px;
    line-height: 100px;
}

.systemDiv {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    padding-left: 10px;
}

.systemName {
    height: 20px;
    color: #5676A5;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
}

.systemClick {
    margin-left: 6px;
    color: #fff;
    font-size: 14px;
    font-weight: 400;
}

.systemSum {
    height: 40px;
    line-height: 40px;
    color: #FC3465;
    font-size: 36px;
    font-weight: 400;
}

.systemUnit {
    color: #E66F89;
    font-size: 16px;
    font-weight: 400;
}

.chinaMapBox {
    display: flex;
    flex: 1;
    position: relative;
}


.divRoll {
    position: absolute;
    width: 200px;
    height: 200px;
    right: 10px;
    overflow: hidden;
}

/* .divRoll {
  width: 100%;
  height: 400px;
  background-color: orange;
  overflow: hidden;
} */
.divRoll ul {
    list-style: none;
    position: relative;
    padding: 0px;
}

.divRoll ul li {
    line-height: 40px;
    color: #fff;
}

.divRoll .content {
    display: flex;
}

.divRoll .content span {
    margin-left: 20px;
    line-height: 40px;
}

@keyframes rowup {
    0% {
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate(0, 0);
    }

    100% {
        -webkit-transform: translate3d(0, -400px, 0);
        transform: translate(0, -400px);
    }

    /* 0% {
    transform: translate(0, 0);
  }
  80%,
  100%  {
    transform: translate(0, calc(var(--h) * -1px));
  } */
}

.divRoll ul.rowup {
    -webkit-animation: 10s rowup linear infinite normal;
    animation: 10s rowup linear infinite normal;
    position: relative;
}

.mapBottom {
    margin-top: 12px;
    height: 120px;
    border: 1px solid;
    border-radius: 5px;
    background: linear-gradient(to left, #494e56, #494e56) left top no-repeat,
        linear-gradient(to bottom, #494e56, #494e56) left top no-repeat,
        linear-gradient(to left, #494e56, #494e56) right top no-repeat,
        linear-gradient(to bottom, #494e56, #494e56) right top no-repeat,
        linear-gradient(to left, #494e56, #494e56) left bottom no-repeat,
        linear-gradient(to bottom, #494e56, #494e56) left bottom no-repeat,
        linear-gradient(to left, #494e56, #494e56) right bottom no-repeat,
        linear-gradient(to left, #494e56, #494e56) right bottom no-repeat;
    background-size: 2px 12px, 12px 2px, 2px 12px, 12px 2px;
    align-items: center;
    display: flex;
    justify-content: flex-start;
    padding: 0px 20px;
    flex-wrap: wrap;
    overflow: hidden;
}

.topDiv {
    width: 136px;
    height: 88px;
    background: url(../../style/img/line1.png) no-repeat;
    background-position: center;
    background-size: 100% 100%;
    display: flex;
    margin-left: 20px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding-left: 16px;
    margin-top: 16px;
}

.topName {
    font-size: 18px;
    font-weight: 400;
    text-align: center;
    color: #929598;
}

.topSU {
    display: flex;
    height: 40px;
    align-items: center;
}

.topSum {
    font-size: 36px;
    font-weight: 400;
    text-align: left;
    color: #67adff;
}

.topUnit {
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    color: #00cfff;
    margin-top: 14px;
}

.right1 {
    width: 508px;
    height: 76px;
    background: #00142c;
    border: 2px solid #263342;
    border-radius: 5px;
    padding: 0px 40px;
    display: flex;
    align-items: center;
    box-shadow: 0px 0px 25px 6px #05264e inset;
}

.right2 {
    width: 508px;
    height: 266px;
    background: #00142c;
    border: 2px solid #263342;
    border-radius: 5px;
    box-shadow: 0px 0px 25px 6px #05264e inset;
    margin-top: 16px;
}

.right2Content {
    width: 100%;
    height: calc(100% - 52px);
    display: flex;
    /* padding: 0px 10px; */
    flex-wrap: wrap;
    /* justify-content: space-between; */
}

.right2Div {
    width: 116px;
    height: 88px;
    background: url(../../style/img/line4.png) no-repeat;
    background-position: center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 0px 10px;
    margin-left: 8px;
}

.right2DivName {
    font-size: 16px;
    font-weight: 400;
    color: #d6d7d9;
}

.right2DivSU {
    display: flex;
    height: 40px;
    align-items: center;
}

.right2DivSum {
    font-size: 26px;
    font-weight: 400;
    color: #67adff;
}

.right2DivUnit {
    font-size: 16px;
    font-weight: 400;
    color: #929598;
    margin-top: 4px;
    margin-left: 20px;
}

.right3 {
    width: 508px;
    height: 278px;
    background: #00142c;
    border: 2px solid #263342;
    border-radius: 5px;
    box-shadow: 0px 0px 25px 6px #05264e inset;
    margin-top: 16px;
    position: relative;
}

.right3Title {
    position: absolute;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    top: 20px;
    right: 50px;
}

.right3Char {
    height: calc(100% - 52px);
    padding: 0px 20px;
}

.right4 {
    display: flex;
    height: 88px;
    margin-top: 16px;
    justify-content: space-between;
}

.right4Div {
    background: url(../../style/img/line5.png) no-repeat;
    background-position: center;
    background-size: 100% 100%;
    width: 156px;
    height: 88px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 0px 16px;
}

.right4DivTitle {
    display: flex;
    align-items: center;
}

.right4DivName {
    font-size: 16px;
    font-weight: 400;
    color: #d6d7d9;
    margin-left: 10px;
}

.right4DivSum {
    font-size: 26px;
    font-weight: 400;
    color: #67adff;
}

.right5 {
    width: 508px;
    height: 133px;
    background: #00142c;
    border: 2px solid #263342;
    border-radius: 5px;
    box-shadow: 0px 0px 25px 6px #05264e inset;
    margin-top: 16px;
}

.right5Content {
    height: calc(100% - 52px);
    padding: 0px 20px;
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.right5Div {
    display: flex;
    flex-direction: column;
}

.right5DivName {
    font-size: 16px;
    font-weight: 400;
    color: #d6d7d9;
}
</style>
  